exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SampleGraph-a606091b{width:100%}\n", ""]);

// Exports
exports.locals = {
	"SampleGraph": "SampleGraph-a606091b"
};